module.exports = __webpack_public_path__ + "img/rate-criteria.82ae8fea.png";